import styled, { css } from 'styled-components';
import { observer } from 'mobx-react-lite';

import { ShareLinkItem } from './share-link-item';
import { PagePlaceholder } from '../../../components/page-placeholder/page-placeholder';
import { ListViewHeader } from '../../../components/list-view/list-view';
import { SortableHeaderCell } from '../../../components/ordered-list/sortable-header-cell';
import { useOrderBy } from '../../../components/ordered-list/use-order-by';
import { useCurrentProject } from '../../../hooks/use-current-project';

export const ShareLinkList = observer(() => {
  const project = useCurrentProject()!;
  const { orderBy, toggleOrder, sort } = useOrderBy();

  if (project.shareLinks.length === 0) {
    return (
      <PagePlaceholder
        title="No files or links shared yet."
        description="You can share multiple items for viewing, commenting or downloading from inside the file's step."
      />
    );
  }

  const shareLinks = sort(project.shareLinks);

  return (
    <Table>
      <ListViewHeader>
        <SortableCell sortKey="name" orderBy={orderBy} onOrder={toggleOrder}>
          Name
        </SortableCell>
        <SortableCell sortKey="createdAt" orderBy={orderBy} onOrder={toggleOrder}>
          Creation date
        </SortableCell>
        <HeaderCell>Number of items</HeaderCell>
        <HeaderCell>Creator</HeaderCell>
        <HeaderCell>Allow download</HeaderCell>
        <HeaderCell />
      </ListViewHeader>

      <TableBody>
        {shareLinks.map((link) => (
          <ShareLinkItem key={link._id} link={link} />
        ))}
      </TableBody>
    </Table>
  );
});

const Table = styled.table`
  width: 100%;
`;

const TableBody = styled.tbody``;

const headerCellStyles = css`
  color: var(--color-grayscale-shuttle);
  font-size: 1.4rem;
  font-weight: 400;
  text-align: left;
  width: 1%;
  white-space: nowrap;

  &:nth-child(4) {
    width: 100%;
  }

  &:not(:last-child) {
    padding-right: 9.6rem;
  }
`;

const HeaderCell = styled.th`
  ${headerCellStyles}
`;

const SortableCell = styled(SortableHeaderCell)`
  ${headerCellStyles}
`;
